<template>
  <div>
    <v-btn outlined small @click="handleGetReport">
      <v-img
        v-if="!isReportLoading"
        class="mr-2 pull-right"
        width="1.5em"
        height="1.5em"
        src="@/assets/images/icons/menu_reporting_pane_white.png"
      >
      </v-img>
      <Loader
        v-if="isReportLoading"
        size="small"
        color="black"
        text=""
        class="mr-2 pull-right"
      ></Loader>
      <span class="text-uppercase">{{
        this.selectedLocation.type + " Report"
      }}</span>
    </v-btn>
  </div>
</template>

<script>
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";
import {
  getWaterReport,
  getCityReport,
} from "@/services/reporting/reporting.service";

export default {
  name: "RisksReport",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    selectedLocation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isReportLoading: false,
    };
  },
  methods: {
    async handleGetReport() {
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.control_risk_risk_ratings,
        EVENT_ACTIONS.clicked,
        this.selectedLocation.type + " Report " + this.selectedLocation.name
      );
      let requestTimestamp = new Date().toISOString();
      let locationCode = this.selectedLocation.code.toUpperCase();
      this.isReportLoading = true;
      if (this.selectedLocation.type === "water") {
        await getWaterReport({ waterCode: locationCode }, requestTimestamp);
      } else if (this.selectedLocation.type === "city") {
        await getCityReport({ cityCode: locationCode }, requestTimestamp);
      }
      this.isReportLoading = false;
    },
  },
};
</script>

<style scoped></style>
